/**
 * Order Management — клиентская страница списка заказов (/projectorders).
 *
 * Клики по строкам (навигация), раскрытие деталей на mobile, смена статуса через AJAX,
 * print, export.
 */

import { apiRequest, APIError } from '../../api.js';

function slideToggle(element, open, duration = 300) {
    if (open) {
        element.style.display = '';
        element.style.overflow = 'hidden';
        element.style.height = '0px';
        const full = element.scrollHeight;
        element.style.transition = `height ${duration}ms ease`;
        requestAnimationFrame(() => { element.style.height = full + 'px'; });
        setTimeout(() => {
            element.style.height = '';
            element.style.overflow = '';
            element.style.transition = '';
        }, duration);
    } else {
        element.style.overflow = 'hidden';
        element.style.height = element.scrollHeight + 'px';
        element.style.transition = `height ${duration}ms ease`;
        requestAnimationFrame(() => { element.style.height = '0px'; });
        setTimeout(() => {
            element.style.display = 'none';
            element.style.height = '';
            element.style.overflow = '';
            element.style.transition = '';
        }, duration);
    }
}

function initOrderManagement() {
    // Row click → navigate to detail (но не при клике на ссылки/кнопки внутри)
    document.querySelectorAll('.adm_orders_item').forEach(item => {
        item.addEventListener('click', e => {
            if (e.target.closest('a, button')) return;
            const href = item.dataset.href;
            if (href) window.location.href = href;
        });
    });

    // Раскрытие детали на mobile
    document.addEventListener('click', e => {
        const caption = e.target.closest('.adm_orders_item_captions');
        if (!caption || window.innerWidth > 768) return;

        e.stopPropagation();
        const item = caption.closest('.adm_orders_item');
        if (!item) return;

        const contents = item.querySelectorAll('.adm_orders_item_grid_mobile, .adm_orders_sup_mobile');
        const isOpening = !item.classList.contains('expanded');

        contents.forEach(el => slideToggle(el, isOpening, 300));
        item.classList.toggle('expanded', isOpening);
    });

    // Order status select → AJAX
    document.querySelectorAll('.order-status-select').forEach(select => {
        select.addEventListener('change', async () => {
            const orderId = select.dataset.orderId;
            const statusType = select.dataset.statusType; // 'payment' | 'delivery'
            const statusId = select.value;

            try {
                const response = await apiRequest('/orders/update-status', {
                    method: 'POST',
                    body: {
                        order_id: orderId,
                        status_type: statusType,
                        status_id: statusId,
                    },
                });
                if (response?.success) {
                    window.showToast('success', 'Status updated successfully');
                } else {
                    window.showToast('error', 'Failed to update status');
                }
            } catch (e) {
                const msg = e instanceof APIError ? e.message : 'Error updating status';
                window.showToast('error', msg);
            }
        });
    });

    // Print
    document.querySelectorAll('.btn-print-order').forEach(btn => {
        btn.addEventListener('click', () => window.print());
    });

    // Export
    document.querySelectorAll('.btn-export-order').forEach(btn => {
        btn.addEventListener('click', () => {
            const orderId = btn.dataset.orderId;
            const format = btn.dataset.format || 'pdf';
            window.location.href = `/orders/${orderId}/export?format=${format}`;
        });
    });

    // Responsive table wrap
    if (window.innerWidth <= 768) {
        document.querySelectorAll('.adm_orders_item_table').forEach(table => {
            if (!table.parentElement.classList.contains('table-responsive')) {
                const wrapper = document.createElement('div');
                wrapper.className = 'table-responsive';
                table.parentNode.insertBefore(wrapper, table);
                wrapper.appendChild(table);
            }
        });
    }

    // Window resize: скрыть мобильные details если перешли на desktop
    let resizeTimer;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
            if (window.innerWidth > 768) {
                document.querySelectorAll('.adm_orders_item_grid_mobile, .adm_orders_sup_mobile').forEach(el => {
                    el.style.display = 'none';
                });
                document.querySelectorAll('.adm_orders_item.expanded').forEach(el => {
                    el.classList.remove('expanded');
                });
            }
        }, 250);
    });
}

// Добавить CSS для стрелок раскрытия на mobile
function injectStyles() {
    const styleId = 'order-management-styles';
    if (document.getElementById(styleId)) return;

    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
        .adm_orders_item.expanded .adm_orders_item_captions:after { content: '▲'; float: right; }
        .adm_orders_item .adm_orders_item_captions:after { content: '▼'; float: right; }
        @media (min-width: 769px) {
            .adm_orders_item .adm_orders_item_captions:after,
            .adm_orders_item.expanded .adm_orders_item_captions:after { display: none; }
        }
        .table-responsive { overflow-x: auto; -webkit-overflow-scrolling: touch; }
    `;
    document.head.appendChild(style);
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        injectStyles();
        initOrderManagement();
    });
} else {
    injectStyles();
    initOrderManagement();
}
